import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import Swal from "sweetalert2";
import { uploadFileViaPresignedUrl } from "../../utils/uploadFileViaPresignedUrl";
import { deleteUserFolder } from "../../utils/deleteUserFolder";

export default function QuestionGenerator({ chatbotTitle, link }) {
  const [csvFile, setCsvFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [trainload, setTrainload] = useState(false);
  const [answerload, setAnswerload] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [error, setError] = useState("");
  const [genaiaccess, setgenaiaccess] = useState(false);

  const [selectedModel, setSelectedModel] = useState(
    "anthropic.claude-haiku-4-5-20251001-v1:0",
  );
  const [modeltext, setModelText] = useState("Claude Haiku");
  const [numberOfQuestions, setNumberOfQuestions] = useState("");
  const [questionInputError, setQuestionInputError] = useState("");
  const [generatedQuestions, setGeneratedQuestions] = useState("");
  const [displayText, setDisplayText] = useState("");

  const timetaken = useRef(0);

  useEffect(() => {
    if (generatedQuestions.length > 0) {
      setDisplayText("");
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + generatedQuestions[index]);
        index++;
        if (index === generatedQuestions.length) {
          clearInterval(intervalId);
        }
      }, 18);
      return () => clearInterval(intervalId);
    }
  }, [generatedQuestions]);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";
    setgenaiaccess(email.includes("genai2244"));
  }, []);

  const getUsername = () =>
    localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {}
  }

  const handleFileChange = (event) => {
    setCsvFile(event.target.files[0]);
  };

  const handleNumberChange = (e) => {
    const val = e.target.value;

    if (val === "" || /^\d+$/.test(val)) {
      const num = parseInt(val);
      if (val === "") {
        setNumberOfQuestions("");
        setQuestionInputError("");
      } else if (num < 1) {
        setNumberOfQuestions(val);
        setQuestionInputError("Minimum 1 question required.");
      } else if (num > 50) {
        setNumberOfQuestions("50");
        setQuestionInputError("Maximum limit is 50 questions.");
      } else {
        setNumberOfQuestions(val);
        setQuestionInputError("");
      }
    }
  };

  const handleUpload = async () => {
    if (!csvFile) {
      Swal.fire("Please select a PDF file first.");
      return;
    }
    setcsvload(true);
    setError("");
    try {
      const username = getUsername();
      await deleteUserFolder(username);
      await uploadFileViaPresignedUrl(csvFile, username);
      setcsvload(false);
      setError("File uploaded successfully.");
      setUploadStatus(true);
    } catch (err) {
      console.error("Upload failed:", err);
      setError("Error uploading file, please refresh and try again.");
      setcsvload(false);
    }
  };

  const handleTrain = async () => {
    if (!csvFile) {
      Swal.fire("Please upload a PDF file first.");
      return;
    }
    setTrainload(true);
    const username = getUsername();
    var data = JSON.stringify({
      docpath: username,
      docname: csvFile.name,
    });
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        if (this.responseText.toString().includes("errorMessage")) {
          Swal.fire("Training failed. Please upload the file again.");
          setTrainload(false);
        } else {
          setError("Training completed!");
          setTrainload(false);
        }
      }
    });
    xhr.open(
      "POST",
      "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/custom-chatbot",
    );
    xhr.send(data);
  };

  const handleGenerateQuestions = async () => {
    if (!numberOfQuestions || parseInt(numberOfQuestions) < 1) {
      setQuestionInputError("Please enter a number between 1 and 50.");
      return;
    }

    const username = getUsername();
    timetaken.current = 0;
    let time = setInterval(() => {
      timetaken.current = parseFloat(timetaken.current) + 0.1;
    }, 100);
    setAnswerload(true);
    setGeneratedQuestions("");
    setDisplayText("");

    var data = JSON.stringify({
      number_of_FAQ: parseInt(numberOfQuestions),
      model: selectedModel,
      docpath: username,
    });

    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        clearInterval(time);
        setAnswerload(false);
        console.log("Raw response:", this.responseText);
        try {
          const response = JSON.parse(this.responseText);
          console.log("Parsed:", response);
          console.log("Keys:", Object.keys(response));
          if (response["messsage"]) {
            setGeneratedQuestions(response["messsage"]);
          } else if (response["errorMessage"]) {
            setGeneratedQuestions("Something went wrong. Please try again.");
          }
        } catch (e) {
          setGeneratedQuestions("Something went wrong. Please try again.");
        }
      }
    });

    xhr.open(
      "POST",
      "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/faq-generator",
    );
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(data);
  };

  const handleExport = () => {
    if (!generatedQuestions) return;
    const blob = new Blob([generatedQuestions], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "generated_questions.txt";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  return (
    <div>
      <div>
        <img
          alt=""
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          alt=""
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>

      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <Grid
              style={{ display: "flex", position: "relative", zIndex: "4" }}
            >
              <Link to={link}>
                <Button variant="contained" component="span" color="primary">
                  Back
                </Button>
              </Link>
            </Grid>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {chatbotTitle}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={signOut}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div className="emailsum-container" style={{ alignContent: "start" }}>
          {/* Training window */}
          <div
            className="input-form-chatbot"
            style={{ margin: "0 2rem", minWidth: "400px", width: "40%" }}
          >
            <h3>
              <strong>Training Window</strong>
            </h3>
            <hr style={{ background: "white" }} />

            <div className="field">
              <p>Select PDF file to train:</p>
              <input
                accept=".pdf"
                id="csv-upload"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label htmlFor="csv-upload">
                <Button variant="contained" component="span">
                  Select PDF
                </Button>
              </label>
              <Typography variant="body1">
                {csvFile && `Selected file: ${csvFile.name}`}
              </Typography>
              <br />
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!csvFile}
                  onClick={handleUpload}
                  startIcon={
                    csvload && (
                      <CircularProgress style={{ color: "white" }} size={20} />
                    )
                  }
                >
                  Upload
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  style={{ color: "white" }}
                  onClick={handleTrain}
                  startIcon={
                    trainload && (
                      <CircularProgress style={{ color: "white" }} size={20} />
                    )
                  }
                >
                  Train
                </Button>
                {uploadStatus && (
                  <FaCheckCircle style={{ color: "green" }} size={25} />
                )}
              </div>
              <br />
              <span style={{ color: "white" }}>{error}</span>
            </div>

            <br />

            <FormControl>
              <p>Select a model:</p>
              <RadioGroup
                name="model-group"
                value={selectedModel}
                onChange={(e) => {
                  setSelectedModel(e.target.value);
                  setModelText(
                    e.target.value === "meta.llama3-70b-instruct-v1:0"
                      ? "LLAMA 3"
                      : "Claude Haiku",
                  );
                }}
              >
                <FormControlLabel
                  value="anthropic.claude-haiku-4-5-20251001-v1:0"
                  control={<Radio />}
                  label="Claude Haiku"
                />
                <FormControlLabel
                  value="meta.llama3-70b-instruct-v1:0"
                  control={<Radio />}
                  label="LLAMA 3"
                />
              </RadioGroup>
            </FormControl>

            <br />

            <p>Number of questions to generate (max 50):</p>
            <TextField
              variant="outlined"
              placeholder="Enter a number (1 - 50)"
              value={numberOfQuestions}
              onChange={handleNumberChange}
              style={{
                border: "1px solid white",
                borderRadius: "0.5rem",
                width: "220px",
              }}
              inputProps={{
                maxLength: 2,
                style: {
                  color: "white",
                },
              }}
              InputProps={{
                style: {
                  color: "white",
                },
              }}
            />
            {questionInputError && (
              <p
                style={{
                  color: "#ff6b6b",
                  fontSize: "13px",
                  margin: "4px 0 0",
                }}
              >
                {questionInputError}
              </p>
            )}

            <br />
            <br />

            <Button
              variant="contained"
              color="primary"
              style={{ color: "white", margin: "0.5rem 0" }}
              onClick={handleGenerateQuestions}
              startIcon={
                answerload && (
                  <CircularProgress style={{ color: "white" }} size={20} />
                )
              }
            >
              Generate Questions
            </Button>
          </div>

          {/* Generate question window */}
          <div className="result-chatbot">
            <h3>
              <strong>Generated Questions</strong>
            </h3>
            <hr style={{ background: "white" }} />

            <div
              style={{
                minHeight: "400px",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "0.5rem",
                padding: "1.5rem",
                color: "white",
              }}
            >
              {answerload ? (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  <CircularProgress size={20} style={{ color: "white" }} />
                  <span>Generating questions...</span>
                </div>
              ) : displayText ? (
                <pre
                  style={{
                    color: "white",
                    fontFamily: "sans-serif",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                    margin: 0,
                  }}
                >
                  {displayText}
                </pre>
              ) : (
                <p
                  style={{
                    color: "rgba(255,255,255,0.4)",
                    fontStyle: "italic",
                  }}
                >
                  Upload a PDF, train, select options and click "Generate
                  Questions".
                </p>
              )}
            </div>

            {generatedQuestions && (
              <div style={{ margin: "1rem auto", textAlign: "right" }}>
                <Button
                  onClick={handleExport}
                  variant="contained"
                  color="primary"
                >
                  Export Questions
                </Button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
